<template>
<div>
<DataTable :value="items" :paginator="true" class="p-datatable-suppliers" :rows="10"
            dataKey="id" :rowHover="true" v-model:selection="selectedItems" v-model:filters="filters" filterDisplay="menu" :loading="loading"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" :rowsPerPageOptions="[5,10,25,50,100]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            :globalFilterFields="['name','inputfield.name']" responsiveLayout="scroll">
            <template #header>
            	<div class="grid">
            		<div class="col-12 md:col-6">
            			<div class="flex justify-content-start align-items-center">
            				<Dropdown v-if="selectedItems.length" v-model="selectedaction" placeholder="Seçili öğeleri..." :options="selectedactions" optionLabel="name" :editable="false" optionDisabled="disabled" @change="selectAction"/>
            			</div>
            		</div>

            		<div class="col-12 md:col-6">
            			<div class="flex justify-content-end align-items-center">
            				<span class="p-input-icon-left">
		                        <i class="pi pi-search" />
		                        <InputText v-model="filters['global'].value" placeholder="Arama" />
		                    </span>
            			</div>
            		</div>

            	</div>
                 
            </template>
            <template #empty>
                No data found.
            </template>
            <template #loading>
                Loading data data. Please wait.
            </template>
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>

            <Column field="name" :header="$store.state.languages.lang_phrases.isim" sortable style="min-width: 14rem">
                <template #body="{data}">
                   <p>{{data.name}}</p>
                </template>
                <template #filter="{filterModel}">
                    <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by name"/>
                </template>
            </Column>

            <Column field="inputfield" filterField="inputfield.name" :header="$store.state.languages.lang_phrases.soru" sortable style="min-width: 14rem" v-if="itemtype==2 || itemtype==3">
                <template #body="{data}">
                    <p>{{data.inputfield.name}}</p>
                </template>
                <template #filter="{filterModel}">
                    <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by inputfield"/>
                </template>
            </Column>

           

            
           

        	
           
          
            
            
            
           
        </DataTable>
</div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';


export default {

  name: '"QuestionlistBatchEditModalTable"',
  props:["items","itemtype"],
  data () {
    return {
    	selectedItems:[],
    	selectedaction:"placeholder",
    	filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]}, 
        'inputfield.name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]}, 
    	},
    	loading: false,
        selectedactions:[
             {
                name:"Seçili öğeleri...",
                action:"placeholder",
                disabled:true
            },
            {
                name:"Düzenle",
                action:"edit"
            },
        ]
    }
  },
   
  methods:{
  	selectAction()
  	{
        console.log(this.selectedItems)
        this.$emit("itemsSelected", this.selectedItems);
  	},
    closemodal()
    {
        this.selectedaction = "placeholder"
    },
  	toggle(event) {
        this.$refs.menu.toggle(event);
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-suppliers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>